// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "./Box.res.js";
import * as Nav from "../navigation/Nav.res.js";
import * as React from "react";
import * as Inline from "./Inline.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  wrapper: {
    "backgroundColor-kWkggS": "backgroundColor-xjbqb8w",
    "transition-kmkexE": "transition-x1ic9zro",
    "bottom-krVfgx": "bottom-x1ey2m1c",
    "height-kZKoxP": "height-xng8ra",
    "left-kbCHJM": "left-xu96u03",
    "position-kVAEAm": "position-xixxii4",
    "right-kCIrl2": "right-x3m8u43",
    "zIndex-kY2c9j": "zIndex-x11uqc5h",
    $$css: "wino-gc:src/resources/layout-and-structure/PageBottomActionsBar.res.js:13"
  },
  wrapperHidden: {
    "transition-kmkexE": "transition-x14r2iph",
    "height-kZKoxP": "height-xqtp20y",
    "overflow-kVQacm": "overflow-xb3r6kr",
    $$css: "wino-gc:src/resources/layout-and-structure/PageBottomActionsBar.res.js:23"
  }
};
function wrapperStyleFromParams(navOpened, show) {
  return [show ? {} : styles.wrapperHidden, navOpened !== undefined ? navOpened ? {
    left: String(Nav.openedSize + 1) + "px"
  } : {
    left: String(Nav.closedSize + 1) + "px"
  } : {
    left: "0px"
  }];
}
function findScrollableParent(_element) {
  while (true) {
    let element = _element;
    let parent = element.parentElement;
    if (parent == null) {
      return;
    }
    if (parent.scrollHeight > parent.clientHeight) {
      return Primitive_option.some(parent);
    }
    _element = parent;
    continue;
  }
  ;
}
function PageBottomActionsBar(props) {
  let __renderStart = props.renderStart;
  let __displayThreshold = props.displayThreshold;
  let displayThreshold = __displayThreshold !== undefined ? __displayThreshold : 100;
  let renderStart = __renderStart !== undefined ? __renderStart : () => null;
  let match = React.useState(() => false);
  let setShow = match[1];
  let wrapperRef = React.useRef(null);
  React.useLayoutEffect(() => {
    let scrollElement = Stdlib_Option.flatMap(Primitive_option.fromNullable(wrapperRef.current), findScrollableParent);
    let handler = param => {
      if (scrollElement === undefined) {
        return;
      }
      let scrollElement$1 = Primitive_option.valFromOption(scrollElement);
      setShow(param => scrollElement$1.scrollTop >= displayThreshold);
    };
    handler();
    Stdlib_Option.forEach(scrollElement, scrollElement => {
      scrollElement.addEventListener("scroll", handler);
    });
    return () => Stdlib_Option.forEach(scrollElement, scrollElement => {
      scrollElement.removeEventListener("scroll", handler);
    });
  }, []);
  let newrecord = {
    ...Stylex.props(styles.wrapper, wrapperStyleFromParams(props.navOpened, match[0]))
  };
  newrecord.ref = Primitive_option.some(wrapperRef);
  let newrecord$1 = {
    ...{
      className: "backgroundColor-x17suf5r boxShadow-x1i7cj58 alignItems-x6s0dn4 display-x78zum5 height-x5yr21d justifyContent-x1qughib paddingBlock-xqp6ajr paddingInline-x15ldat2 zIndex-x11uqc5h",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/PageBottomActionsBar.res.js:28"
    }
  };
  newrecord.children = JsxRuntime.jsxs("div", (newrecord$1.children = [JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Inline.make, {
      children: renderStart()
    }),
    spaceX: "medium"
  }), JsxRuntime.jsx(Box.make, {
    children: props.renderEnd(),
    spaceX: "medium"
  })], newrecord$1));
  return JsxRuntime.jsx("div", newrecord);
}
let make = React.memo(PageBottomActionsBar);
export { make };
/* styles Not a pure module */